import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './Pages/Home';
import About from './Pages/About';
import Product from './Pages/Product';
import Contact from './Pages/Contact'; // not "Contat"
import Gallery from './Pages/Gallery';
import IFS from './Pages/Ifs';
import IFSS from './Pages/Ifss';
import IFCI from './Pages/Ifci';
import IFA from './Pages/Ifa';
import CI from './Pages/Ci';
import PCD from './Pages/Pcd';
import CBN from './Pages/Cbn';
import TH from './Pages/Th';
import BB from './Pages/Bb';
import FM from './Pages/Fm';
import ET from './Pages/Et';
import IT from './Pages/It';
import CIRCLIP from './Pages/Circlip'
import PARTING from './Pages/Parting'
import SPT from './Pages/Spt'
import CATA from './Pages/Cata'
import ENQUIRY from './Pages/Enquiry'
import FIX from './Pages/fix'

function App() {
  return (


    <>    <Router>
     
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Products" element={<Product />} />
        <Route path="/Ifs" element={<IFS/>} />
        <Route path="/Ifss" element={<IFSS/>} />
        <Route path="/Ifci" element={<IFCI/>} />
        <Route path="/Ifa" element={<IFA/>} />
        <Route path="/Ci" element={<CI/>} />
        <Route path="/Pcd" element={<PCD/>} />
        <Route path="/Cbn" element={<CBN/>} />
        <Route path="/Th" element={<TH/>} />
        <Route path="/Bb" element={<BB/>} />
        <Route path="/Fm" element={<FM/>} />
        <Route path="/Et" element={<ET/>} />
        <Route path="/It" element={<IT/>} />
        <Route path="/Spt" element={<SPT/>} />
        <Route path="/Cata" element={<CATA/>} />
        <Route path="/Circlip" element={<CIRCLIP/>} />
        <Route path="/Parting" element={<PARTING/>} />
        <Route path="/Enquiry" element={<ENQUIRY/>} />
       

        <Route path="/Contact" element={<Contact />} />
        <Route path="/Gallery" element={<Gallery />} />
      </Routes>
    </Router>


<FIX/>

</>


  );
}

export default App;
